<template>
	<div class="banner-bottom container">
		<span class="btn-close" @click="close">
			x
		</span>
		<span class="banner-title">
			Download our Mobile App for additional features
		</span>
		<div class="store-buttons-holder">
			<a
				v-if="!isIos"
				href="https://play.google.com/store/apps/details?id=com.smarttab.customerapp&hl=en"
				class="store-button google-play"
				target="_blank"
			>
				Get it on Google Play
			</a>
			<a
				v-if="!isAndroid"
				href="https://apps.apple.com/us/app/smarttab-customer-app/id1078218717"
				class="store-button app-store"
				target="_blank"
			>
				Download on the App Store
			</a>
		</div>
	</div>
</template>

<script>
export default {
	name: 'AppsBanner',

	computed: {
		userAgent() {
			return navigator.userAgent || navigator.vendor || window.opera
		},

		isAndroid() {
			return /android/i.test(this.userAgent)
		},

		isIos() {
			return (
				/iPad|iPhone|iPod|Macintosh/.test(this.userAgent) && !window.MSStream
			)
		}
	},

	methods: {
		close() {
			this.$emit('close')
		}
	}
}
</script>

<style lang="scss">
@import './src/assets/styles/variables';

.banner-bottom {
	position: fixed;
	z-index: 99;
	bottom: 0;
	left: 0;
	right: 0;
	padding: 3px 44px;
	vertical-align: middle;
	text-align: center;
	font-size: 12px;
	background: $background-box;

	.btn-close {
		position: absolute;
		left: 13px;
		top: 22px;
		width: 34px;
		height: 34px;
		margin: -17px 0 0;
		opacity: 1;
		transition: opacity 0.3s;
		&:hover {
			opacity: 0.7;
		}
		&:before,
		&:after {
			left: 8px;
			top: 15px;
		}
	}

	.banner-title {
		display: inline-block;
		padding: 10px 0;
		color: #fff;

		.mark {
			color: #9b9b9b;
		}
	}

	.store-button {
		display: inline-block;
		vertical-align: middle;
		margin: 5px 0 5px 16px;
		opacity: 1;
		transition: opacity 0.3s;
		&:hover {
			opacity: 0.7;
		}
	}

	@media (max-width: 767px) {
		display: block;
		padding: 12px 44px;

		.btn-close {
			top: 30px;
		}
	}
}

.store-buttons-holder {
	display: inline-block;
	vertical-align: middle;
}
</style>
